let language = {
    "4000": "Not allow to upload this file",
    "4001": "The file content is illegal",
    "4101": "The file content is illegal",
};

export { language }